import { render, staticRenderFns } from "./TicketComments.vue?vue&type=template&id=2791f68a"
import script from "./TicketComments.js?vue&type=script&lang=js&external"
export * from "./TicketComments.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports